export default __webpack_public_path__ + "static/media/Armbands of the Berserker's Fury.9adb4127.jpg";